import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'features.retrieveUsername.pageTitle',
    defaultMessage: 'Recupera Username',
    description: 'Title of the retrieve username page',
  },
  pageSubtitle: {
    id: 'features.retrieveUsername.pageSubtitle',
    defaultMessage: 'Seleziona da dove vuoi recuperare i dati',
    description: 'Subtitle of the retrieve username page',
  },
  pageSubtitlePF: {
    id: 'features.userTypeRecovery.pageSubtitlePF',
    defaultMessage:
      'Inserisci il numero di cellulare per recuperare l’username',
    description: 'Subtitle of the user-type recovery page if persona fisica',
  },
  textPF: {
    id: 'features.retrieveUsername.textPF',
    defaultMessage: 'Recupera username via cellulare',
  },
  labelFirstRadioButton: {
    id: 'features.retrieveUsername.labelFirstradioButton',
    defaultMessage: 'Recupera Username via email',
    description: 'Label for first radio button',
  },
  labelSecondRadioButton: {
    id: 'features.retrieveUsername.labelSecondRadioButton',
    defaultMessage: 'Recupera Username via cellulare',
    description: 'Label for second radio button',
  },
  labelEmailInputText: {
    id: 'features.retrieveUsername.labelEmailInputText',
    defaultMessage:
      "Inserisci l'indirizzo email utilizzato per la registrazione",
    description: 'Label for email input text',
  },
  placeholderEmailInputText: {
    id: 'features.retrieveUsername.placeholderEmailInputText',
    defaultMessage: 'Es. nome.cognome@gmail.com',
    description: 'Placeholder for email input text',
  },
  labelPhoneNumberInputText: {
    id: 'features.retrieveUsername.labelPhoneNumberInputText',
    defaultMessage:
      'Inserisci il numero di cellulare utilizzato per la registrazione',
    description: 'Label for phone number input text',
  },
  placeholderPhoneNumberInputText: {
    id: 'features.retrieveUsername.placeholderPhoneNumberInputText',
    defaultMessage: 'Es. +39 333 456 7890',
    description: 'Placeholder for email input text',
  },
  retrieveUsernameButton: {
    id: 'features.retrieveUsername.retrieveUsernameButton',
    defaultMessage: 'Conferma',
    description: 'Label of the retrieve username button',
  },
  disclaimer: {
    id: 'features.retrieveUsername.disclaimer',
    defaultMessage: 'Torna alla ',
  },
  errorTitleInvalidMailFormat: {
    id: 'features.retrieveUsername.errorTitleInvalidMailFormat',
    defaultMessage: 'Indirizzo email non valido',
  },
  errorTitleInvalidPhoneNumberFormat: {
    id: 'features.retrieveUsername.errorTitleInvalidPhoneNumberFormat',
    defaultMessage: 'Numero di cellulare non valido',
  },
  errorTitleEmailNotFound: {
    id: 'features.retrieveUsername.errorTitleEmailNotFound',
    defaultMessage:
      'Non è possibile procedere con il recupero della username, l’indirizzo mail inserito è inesistente',
  },
  errorTitlePhoneNumberNotFound: {
    id: 'features.retrieveUsername.errorTitlePhoneNumberNotFound',
    defaultMessage:
      'Non è possibile procedere con il recupero della username, il numero di cellulare inserito è inesistente',
  },
  errorTitleTooManyRequests: {
    id: 'features.retrieveUsername.errorTitleTooManyRequests',
    defaultMessage:
      'Non è possibile procedere con il recupero della username: hai superato il numero massimo di richieste. Riprova più tardi.',
  },
  errorNoAssociatedUser:{
    id:'features.retrieveUsername.errorNoAssociatedUser',
    defaultMessage:'I dati inseriti non sono associati ad alcuna utenza MyAzimut'
  },
  errorTitleFieldNotValid: {
    id: 'features.retrieveUsername.errorTitleFieldNotValid',
    defaultMessage: 'I dati inseriti non sono corretti',
  },
  errorTitleFieldNotFill: {
    id: 'features.retrieveUsername.errorTitleFieldNotFill',
    defaultMessage: 'Compila almeno un campo',
  },
  pageTitleMultipleMatch: {
    id: 'features.retrieveUsername.pageTitleMultipleMatch',
    defaultMessage: 'Inserisci i dati',
    description: 'Title of the retrieve username multiple match page',
  },
  pageSubtitleMultipleMatch: {
    id: 'features.retrieveUsername.pageSubtitleMultipleMatch',
    defaultMessage: 'Inserisci il Codice Utente o il Codice Accordo Quadro',
    description: 'Subtitle of the retrieve username multiple match page',
  },
  backLinkMultipleMatch: {
    id: 'features.retrieveUsername.backLinkMultipleMatch',
    defaultMessage: 'Indietro',
    description: 'Label link to come back',
  },
  retrieveUsernameMultipleMatchButton: {
    id: 'features.retrieveUsername.retrieveUsernameBuretrieveUsernameMultipleMatchButtontton',
    defaultMessage: 'Conferma',
    description: 'Label of the retrieve username multiple match button',
  },
  labelUserCodeInputText: {
    id: 'features.retrieveUsername.labelUserCodeInputText',
    defaultMessage: 'Codice Utente',
    description: 'Label for user code input text',
  },
  placeholderUserCodeInputText: {
    id: 'features.retrieveUsername.placeholderUserCodeInputText',
    defaultMessage: 'Inserisci il codice utente',
    description: 'Placeholder for user code input text',
  },
  labelSquareAgreementCodeInputText: {
    id: 'features.retrieveUsername.labelSquareAgreementCodeInputText',
    defaultMessage: 'Codice Accordo Quadro (10 Cifre)',
    description: 'Label for square agreement code input text',
  },
  placeholderSquareAgreementCodeInputText: {
    id: 'features.retrieveUsername.placeholderSquareAgreementCodeInputText',
    defaultMessage: 'Inserisci il Codice Accordo Quadro (10 Cifre)',
    description: 'Placeholder for square agreement code input text',
  },
  messageErrorModalInvalidUser: {
    id: 'features.retrieveUsername.messageErrorModalInvalidUser',
    defaultMessage: 'Non è possibile procedere con il recupero della username, l’indirizzo mail inserito è inesistente',
  },
  messageErrorInvalidSquareAgreementCode: {
    id: 'features.retrieveUsername.messageErrorInvalidSquareAgreementCode',
    defaultMessage: 'Il codice Accordo Quadro inserito non è corretto.',
    description: 'Error invalid square agreement code',
  },
  messageErrorModalInvalidUserOrSquareAgreement: {
    id: 'features.retrieveUsername.messageErrorModalInvalidUserOrSquareAgreement',
    defaultMessage: 'I dati inseriti non sono corretti',
    description: 'Error invalid user or square agreement code',
  },
  successMessageRetrieveUsernameByEmail: {
    id: 'features.retrieveUsername.successMessageRetrieveUsernameByEmail',
    defaultMessage:
      'Recupero username completato. Controlla di aver ricevuto l’email per procedere',
    description: 'Success message retrieve Username by email',
  },
  successMessageRetrieveUsernameBySMS: {
    id: 'features.retrieveUsername.successMessageRetrieveUsernameBySMS',
    defaultMessage:
      'Recupero username completato. Controlla di aver ricevuto l’SMS per procedere',
    description: 'Success message retrieve Username by sms',
  },
  successDialogRetrieveUsernameButtonLabel: {
    id: 'features.retrieveUsername.successDialogRetrieveUsernameButtonLabel',
    defaultMessage: 'Chiudi',
    description: 'Success dialog retrieve Username button label',
  },
  insertDataLabel: {
    id: 'features.retrieveUsername.insertDataLabel',
    defaultMessage: 'Inserisci dati',
    description: '',
  },
  subtitileLabelMobile: {
    id: 'features.retrieveUsername.subtitileLabelMobile',
    defaultMessage:
      'Inserisci il Codice Cliente o il codice dell’Accordo Quadro',
    description: '',
  },
});
